import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../../utils/api";
import { shareVariantUsersEndpoint } from "../../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getShareVariantUsers = createApi(shareVariantUsersEndpoint, "GET");

const shareVariantUsersSlice = createSlice({
  name: "ShareVariantUsersSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getShareVariantUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getShareVariantUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getShareVariantUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default shareVariantUsersSlice.reducer;
